module.exports = __webpack_public_path__ + "static/media/Tile Denim.87563440.jpg";